export default "__VITE_ASSET__428fbb1e__"